import { CreditCard, TrendingUp } from 'lucide-react'

export default function ResumoIcmsExclusao({ rubrica, saldo }: { rubrica?: number; saldo?: number }) {
  const formatCurrency = (value: number) => {
    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(value)
  }

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
      {/* Rubricas */}
      <div className="bg-white rounded-xl shadow-sm border border-teal-200 p-6 hover:shadow-md transition-shadow duration-200">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-teal-700">Rubricas</h3>
          <TrendingUp className="w-5 h-5 text-teal-600" />
        </div>
        <p className="text-3xl font-bold text-teal-600 mb-1">{formatCurrency(rubrica ?? 0)}</p>
        <p className="text-sm text-gray-600">Valor total de rubricas</p>
      </div>

      {/* Saldo */}
      <div className="bg-white rounded-xl shadow-sm border border-blue-200 p-6 hover:shadow-md transition-shadow duration-200">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-sm font-medium text-blue-700">Saldo</h3>
          <CreditCard className="w-5 h-5 text-blue-600" />
        </div>
        <p className="text-3xl font-bold text-blue-600 mb-1">{formatCurrency(saldo ?? 0)}</p>
        <p className="text-sm text-gray-600">Saldo disponível</p>
      </div>
    </div>
  )
}
